import React from 'react';

import { useCustomer } from '@/hooks/useCustomer';
import { Permission } from '@/types/permissions';
import { isPermission } from '@/types/permissions.ext';

export interface PermissionsManager {
  userIsAuthorizedTo(role: Permission): boolean;
}

const isNotTeamsPermission = (permission: Permission | string): boolean =>
  !isPermission(permission);

export const usePermissionsManager = (): PermissionsManager => {
  const { permissions } = useCustomer();

  const checkRole = React.useCallback(
    (permission: Permission): boolean => {
      if (permissions.every(isNotTeamsPermission)) {
        return true;
      }

      return permissions.includes(permission);
    },
    [permissions],
  );

  return {
    userIsAuthorizedTo: checkRole,
  };
};
